/**
 * Domain → Tenant Zuordnung
 *
 * Neue Google-Logins aus diesen Firmen-Domains landen beim ersten Login direkt in der
 * Organisation des Unternehmens statt in einer neu angelegten, leeren Organisation.
 * Bestehende Profile werden nicht verschoben.
 */

export interface DomainTenant {
  domain: string;
  orgId: string;
  orgName: string;
}

export const DOMAIN_TENANTS: DomainTenant[] = [
  { domain: 'echomotion.de', orgId: 'org_echomotion_001', orgName: 'Echomotion' },
];

export interface DomainTenantSignIn {
  email?: string | null;
  emailVerified: boolean;
  /** Google-Workspace-Domain aus dem OAuth-Profil (`hd`), fehlt bei privaten Google-Konten */
  hostedDomain?: string | null;
}

/**
 * Liefert die Ziel-Organisation, wenn E-Mail-Domain und Workspace-Domain (`hd`) übereinstimmen
 * und Google die E-Mail verifiziert hat. Ohne `hd` keine Zuordnung – so kann ein privates
 * Google-Konto mit Firmenadresse nicht in den Firmen-Tenant gelangen.
 */
export function resolveDomainTenant({ email, emailVerified, hostedDomain }: DomainTenantSignIn): DomainTenant | null {
  if (!email || !emailVerified || !hostedDomain) return null;

  const emailDomain = email.trim().toLowerCase().split('@').pop();
  const hd = hostedDomain.trim().toLowerCase();
  if (!emailDomain || emailDomain !== hd) return null;

  return DOMAIN_TENANTS.find((tenant) => tenant.domain === hd) ?? null;
}
